import { Box } from '@cdl/heartbeat-react';
import React, { PropsWithChildren } from 'react';

export const Sidebar: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box width='26.5%' position='fixed' right={0}>
      {children}
    </Box>
  );
};
